import React from 'react'

import { EntityDetails } from '../entity-details'
import { IEntityDetailsProps } from '../entity-details/EntityDetails'
import { badgeColorByHouseStatus } from '../../atoms/fields/Badge'
import { HouseStatus } from '../../../lib/graphql'

interface IHouseMainDetailsProps extends IEntityDetailsProps {
  houseStatus?: HouseStatus
  disableHover?: boolean
  ownerAnswerInfos?: {
    answerRate?: number | null | undefined
    avgAnswerTime?: number | null | undefined
  }
  isRecommended?: boolean
}

const HouseMainDetails = ({
  houseStatus,
  disableHover,
  ownerAnswerInfos,
  ...props
}: IHouseMainDetailsProps) => {
  return (
    <EntityDetails
      bgColor={houseStatus ? badgeColorByHouseStatus(houseStatus) : undefined}
      disableHover={disableHover}
      ownerAnswerInfos={ownerAnswerInfos}
      {...props}
    />
  )
}

export default HouseMainDetails
